const comments = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20friendly%20and%20approachable%20expression&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    time: '2小时前',
    content: '努努影院真的太良心了！更新速度超快，画质也很清晰，完全没有乱七八糟的广告弹窗。自从发现这个站，我追剧再也没充过会员，强烈推荐给所有剧荒的朋友！',
    rating: 5,
    tag: '老用户',
  },
  {
    name: '悬疑控晚期',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20confident%20look%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background%2C%20casual%20professional%20style&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    time: '5小时前',
    content: '最喜欢悬疑剧专区，分类很清楚，找剧特别方便。最近在追的那部国产悬疑剧，更新速度和官方平台同步，画质还是1080P，体验完全不输付费平台。',
    rating: 5,
    tag: '悬疑迷',
  },
  {
    name: '韩剧十级学者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20bright%20eyes%2C%20soft%20lighting%2C%20clean%20white%20background%2C%20modern%20casual%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    time: '1天前',
    content: '韩剧资源太全了！连一些比较冷门的老剧都能找到，中文字幕也很及时。海外党用努努毫无压力，加载速度比某些国际平台还快，感动哭了。',
    rating: 4,
    tag: '海外用户',
  },
  {
    name: '二次元阿宅',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20glasses%20and%20friendly%20smile%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20tech%20casual%20style&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    time: '2天前',
    content: '动漫频道现在做得越来越好了！热门新番一应俱全，老番资源也很充足。播放器支持倍速和画中画，吃饭的时候也能追番，简直不要太方便。',
    rating: 5,
    tag: '动漫粉',
  },
  {
    name: '深夜追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20gentle%20smile%2C%20soft%20warm%20lighting%2C%20clean%20neutral%20background%2C%20cozy%20casual%20style&width=80&height=80&seq=avatar-user-05&orientation=squarish',
    time: '3天前',
    content: '下班回家打开努努影院已经成了一种习惯。页面简洁不花哨，找剧不费劲，播放稳定不缓冲。最喜欢那个历史记录功能，继续上次的进度无缝续看。',
    rating: 5,
    tag: '忠实粉丝',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          追剧体验
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          来自真实用户的追剧心声，听听大家都怎么说
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[1100px] mx-auto">
          {comments.map((comment, index) => (
            <div
              key={index}
              className={`bg-background-50 border border-background-200 rounded-2xl p-5 ${
                index >= 3 ? 'lg:col-span-1 md:col-span-1' : ''
              } ${comments.length === 5 && index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-foreground-800 whitespace-nowrap">{comment.name}</span>
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded-full whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}